/**
 * When a bundle app renders multiple product forms with the same ID,
 * only one form can be targeted and settings may apply only to the last product.
 * This script gives each duplicate form a unique ID (e.g. id-0, id-1) so each
 * form is distinct and bundle settings apply per product.
 * Also rewrites form="" attributes so radios/inputs stay associated.
 */
(function () {
  function ensureUniqueFormIds() {
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    var idCount = {};
    var idNextIndex = {};

    forms.forEach(function (form) {
      var id = form.id || 'product-form-bundle';
      idCount[id] = (idCount[id] || 0) + 1;
    });

    forms.forEach(function (form) {
      var id = form.id || 'product-form-bundle';
      if (idCount[id] > 1) {
        var idx = idNextIndex[id] = (idNextIndex[id] || 0);
        idNextIndex[id] += 1;
        var newId = id + '-' + idx;
        form.id = newId;
        document.querySelectorAll('[form="' + id + '"]').forEach(function (el) {
          // Only retarget elements that belong to this form's product context when possible.
          if (form.contains(el)) {
            el.setAttribute('form', newId);
            return;
          }
          var productInfo = form.closest('product-info');
          if (productInfo && productInfo.contains(el)) {
            el.setAttribute('form', newId);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureUniqueFormIds);
  } else {
    ensureUniqueFormIds();
  }

  document.addEventListener('shopify:section:load', ensureUniqueFormIds);
})();
